/**
 * Barre de recherche des pages « Mes contacts ». Champ contrôlé, 44 px de haut,
 * bouton « Effacer » (et Échap) une fois du texte saisi. Le filtrage lui-même vit
 * dans `@/lib/contact-search`.
 */

import { Search, X } from 'lucide-react';

export function ContactSearchInput({
  value,
  onChange,
  placeholder = 'Rechercher un contact…',
  ariaLabel = 'Rechercher dans mes contacts',
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Nom accessible du champ — « Rechercher dans mes fichiers » sur la page Fichiers. */
  ariaLabel?: string;
}) {
  return (
    <div className="relative">
      <Search
        className="text-ink-400 pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2"
        aria-hidden="true"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && value) onChange('');
        }}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        enterKeyHint="search"
        className="border-ink-200 text-ink-900 placeholder:text-ink-400 focus:border-primary-500 h-11 w-full rounded-xl border bg-white pl-10 pr-11 font-sans text-sm transition-colors focus:outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Effacer la recherche"
          className="text-ink-400 hover:text-ink-700 absolute right-0 top-0 flex h-11 w-11 items-center justify-center rounded-xl transition-colors active:scale-[0.98]"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
